export const PRODUCT = 'PRODUCT';
export const PRODUCT_ALL_ACTION = `${PRODUCT}/ALL`;
export const PRODUCT_CREATE_ACTION = `${PRODUCT}/CREATE`;
export const PRODUCT_UPDATE_ACTION = `${PRODUCT}/UPDATE`;
